import React from 'react';
import Link from 'gatsby-link';

import PageHeader from '../../components/header/page';
import ContentBlock from '../../components/contentblock';
import SidebarNav from '../../components/navigation/sidebar';
import InfoBox from '../../components/navigation/infobox';
import BackgroundImage from '../../resources/images/header/dexa.jpg';

const DexaPage = props =>
  (<main>
    <PageHeader headline="DEXA" image={BackgroundImage} />
    <section className="container-custom split">
      <div className="container-custom">
        <ContentBlock title="Vorbereitungen in der Ordination:">
          <ul className="feature-list">
            <li>
              Informieren Sie uns über eventuelle <strong>Hüftprothesen, Wirbelsäulen-Versteifungen</strong> o.ä.
            </li>
            <li>
              Geben Sie Ihre persönliche Daten (<strong>Größe und Gewicht</strong>) an.
            </li>
            <li>
              Die <strong>Anamnese</strong> erfolgt durch das Röntgenpersonal.
            </li>
            <li>
              Entkleiden Sie sich ab der Hüfte bis auf die Unterwäsche.
            </li>
            <li>
              Die Untersuchung erfolgt im Liegen.
            </li>
          </ul>
        </ContentBlock>
        <ContentBlock title="Befundsbesprechung:">
          <ul className="feature-list">
            <li>
              Die Patient/innen erhalten den <strong>Befund</strong> direkt nach der Untersuchung oder per Post.
            </li>
          </ul>
        </ContentBlock>
      </div>
      <aside className="sidebar">
        <SidebarNav />
        <InfoBox name="dexa" />
      </aside>
    </section>
  </main>);

export default DexaPage;


// WEBPACK FOOTER //
// ./src/pages/leistungen/dexa.js